<template>
  <div
    class="order-status-card"
    :class="{ failure: queryType === 'repay' }"
  >
    <template v-if="queryType === 'repay'">
      <img
        class="error-icon"
        src="@/assets/status/error-red.svg"
        width="20px"
        alt=""
      >
      <div class="failure-info">
        <div class="title">
          The transfer information you submitted has failed the platform review.
        </div>
        <div class="sub-text">
          {{ failureReason }} <br>
          Please resubmit the transfer information.
        </div>
      </div>
      <img
        src="@/assets/order/check-failure.svg"
        alt=""
      >
    </template>
    <template v-else>
      <img
        src="@/assets/status/confirm.svg"
        alt=""
      >
      <div class="text">
        Your Order Created <span>Successfully</span>
      </div>
      <div class="circle-1" />
      <div class="circle-2" />
    </template>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { fetchData } from '@/utils/fetch'

const route = useRoute()

const queryType = computed(() => route.query.type)

// 获取订单支付失败信息
const failureReason = ref(null)
const getFailureReason = async () => {
  const { code, data } = await fetchData('/appb/b2b/order/getPayFailMsg?orderNo=' + route.params.orderNo)

  failureReason.value = data
}

onMounted(() => {
  if (queryType.value === 'repay') {
    getFailureReason()
  }
})

</script>

<style lang='less' scoped>
.order-status-card {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 24px;
  border-radius: 8px;
  height: 120px;
  background-color: #141414;
  margin-top: 24px;
  overflow: hidden;

  &.failure {
    background-color: #FFEBEB;
    .error-icon {
      margin-right: 24px;
    }

    .failure-info {
      flex: 1;

      .title {
        color: #232323;
        font-size: 16px;
        font-family: mon-600;
      }

      .sub-text {
        margin-top: 8px;
        color: #232323;
        font-size: 12px;
        font-family: mon-500;
        line-height: 16px;
      }
    }
  }

  .text {
    color: white;
    font-size: 20px;
    font-family: mon-600;
    margin-left: 16px;

    span {
      color: #4681f9;
    }
  }

  .circle-1 {
    position: absolute;
    right: 0;
    top: -200px;
    width: 400px;
    height: 400px;
    border-radius: 50%;
    border: 60px solid #1153D6;
    background-color: #141414;
    z-index: 10;
  }

  .circle-2 {
    position: absolute;
    right: -60px;
    top: -260px;
    width: 520px;
    height: 520px;
    border-radius: 50%;
    background: radial-gradient(circle, #092b70, #1153D6);
  }
}
</style>
